import type {BasicUser, Department, LabeledIdentified} from 'src/typings';
import type {AmountType} from '../../payment/types';

export const CASH_PAYMENT_PROVIDER_TYPE = 'cash';
export const TERMINAL_PAYMENT_PROVIDER_TYPE = 'terminal';
export const GATEWAY_PAYMENT_PROVIDER_TYPE = 'gateway';
export const CASH_PAYMENT_PROVIDER_NAME = 'cash';
export const MANUAL_TERMINAL_PAYMENT_PROVIDER_NAME = 'terminal-virtual';

export interface Transaction extends LabeledIdentified<number> {
    cashier: BasicUser;
    date: string;
    owner: BasicUser;
    sum: number;
    type: AmountType;
    typeId: number;
    payment: boolean;
    paymentId: number;
    debt: boolean;
    cashierDepartment: Department;
    targetDepartment: Department;
}

export interface GroupTransaction extends Pick<Transaction, 'text' | 'sum' | 'type' | 'typeId'> {
    debt: () => boolean;
}

export interface TransactionSums {
    sum: number;
    debtsSum: number;
    creditsSum: number;
}
